<template>
    <div class="cs-accountList-originalCell">
        <span>{{ data.OriginalPrice | toCurrency }}</span>
         <span v-if="data.HasRefund" class="cs-redLabel">(有退款)</span>
         <span v-if="data.IsHalfRefund" class="cs-redLabel">(半价退款)</span>
        <div>
        <span v-if="data.DiscountAmount > 0">优惠:-{{ data.DiscountAmount | toCurrency }}</span>
        <span v-if="data.EnrollmentPrice > 0">占位抵扣:-{{ (data.EnrollmentPrice + data.EnrollmentPriceTax) | toCurrency }}<span v-if="data.EnrollmentPriceTax > 0">(税{{data.EnrollmentPriceTax | toCurrency}})</span></span>
        <span v-if="data.BalanceCost > 0">
          余额抵扣:-{{ data.BalanceCost + data.BalanceCostTax | toCurrency }}
          <span v-if="data.BalanceCostTax > 0">(税{{data.BalanceCostTax | toCurrency}})</span>
          <span class="cs-accountList-balanceCost" v-if="data.AccountType === 12">
            (<span v-if="data.OldBalanceCost > 0">
              旧余额:{{ data.OldBalanceCost | toCurrency }}
            </span>
            <span v-if="data.NewBalanceCost > 0">
              新余额:{{ data.NewBalanceCost | toCurrency }}
            </span>
            <span v-if="data.GiftBalanceCost > 0">
              赠送余额:{{ data.GiftBalanceCost | toCurrency }}
            </span>)
          </span>
        </span>
        <span v-if="data.BonusPointAmount > 0">积分抵扣:-{{ data.BonusPointAmount | toCurrency }}</span>
        <span v-if="data.CashDecreasedAmount > 0">现金减:-{{ data.CashDecreasedAmount | toCurrency }}</span>
        <span v-if="data.CouponDiscountDollar > 0">优惠劵:-{{ data.CouponDiscountDollar | toCurrency }}</span>
        <span v-if="data.BonusPoint > 0">积分:-{{ data.BonusPoint}}</span>
        <span v-if="data.CouponCode">(学生代理)</span>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.cs-accountList-originalCell{
  span{
    display: block;
  }
  .cs-accountList-balanceCost{
    span{
      display: inline;
      padding-left: 5px;
      &:first-of-type{
        padding-left: 0;
      }
    }
  }
}
</style>

<script>

export default {
  props: {
    data: {},
    columnData:{},
    status: {}
  },
  data() {
    return {
    }
  },
  components: {},
  created() {
    
  },
  methods: {
    
  },
  watch: {
    data: function() {
      
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/paginationCells/accountListOriginalPriceCell.vue